import { useRef, useEffect } from "react";

export function useDebounce(pCallback: () => void, pDelay: number) {
	const lLatestCb = useRef<undefined | (() => void)>(),
		lLatestTimeout = useRef<undefined | number>();
	useEffect(
		function () {
			lLatestCb.current = pCallback;
		},
		[pCallback]
	);

	return function () {
		if (!lLatestTimeout.current && lLatestCb.current) {
			lLatestCb.current();
			lLatestTimeout.current = window.setTimeout(function () {
				clearTimeout(lLatestTimeout.current);
			}, pDelay);
			return;
		}
		clearTimeout(lLatestTimeout.current);
		lLatestTimeout.current = window.setTimeout(function () {
			if (lLatestCb.current) lLatestCb.current();
			clearTimeout(lLatestTimeout.current);
		}, pDelay);
	};
}